var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.handleBusqueda }
                })
              ]
            },
            proxy: true
          },
          {
            key: "centro",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.dispositivos,
                    "exported-file-name": "Dispositivos"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("MantenedorGridTodos", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "funcionalidad-id": _vm.funcionalidad,
          "test-id": "Dispositivos"
        },
        on: {
          gridOptionsEnriched: function($event) {
            _vm.enrichedGridOptions = $event
          }
        }
      }),
      _c("CrearDispositivoModal", {
        attrs: { show: _vm.mostrarModalCrear },
        on: {
          cerrar: _vm.handleCierraModalSinGuardar,
          cerrarBtnGuardar: _vm.handleCierreModalBtnGuardar
        }
      }),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleDispositivoModal", {
            attrs: { dispositivoSeleccionado: _vm.dispositivoSeleccionado },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _c("EditarDispositivoModal", {
        attrs: {
          show: _vm.mostrarModalEditar,
          dispositivoSeleccionado: _vm.dispositivoSeleccionado
        },
        on: {
          cerrar: _vm.handleCierraModalSinGuardar,
          cerrarBtnGuardar: _vm.handleCierreModalBtnGuardar
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogEliminar,
          titulo: _vm.tituloConfirmacionEliminar,
          mensaje: _vm.$t("mensajes.crud.eliminar.mensaje", {
            entidad: "el Dispositivo"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: { modalConfirmationEmit: _vm.handleCierreConfirmacionEliminar }
      }),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "480" },
              model: {
                value: _vm.dialogErrorAsoc,
                callback: function($$v) {
                  _vm.dialogErrorAsoc = $$v
                },
                expression: "dialogErrorAsoc"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [
                          _vm.eliminaIndividual
                            ? _c("v-card-text", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.tituloEliminar) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "div",
                    { attrs: { id: "alinear" } },
                    [
                      _vm.eliminaIndividual
                        ? _c("v-card-text", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.mensajeEliminaIndividual) +
                                "\n          "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#526da5", depressed: "", small: "" },
                          on: {
                            click: function($event) {
                              _vm.dialogErrorAsoc = false
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("Aceptar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }